import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPpt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12V17.5M5.25024 14.75H10.7502",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 1H13C14.1046 1 15 1.89543 15 3V5H16V3C16 1.34315 14.6569 0 13 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H13C14.6569 20 16 18.6569 16 17V10H15V17C15 18.1046 14.1046 19 13 19H3C1.89543 19 1 18.1046 1 17V3C1 1.89543 1.89543 1 3 1Z",
			fill: "#222222"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-3-inside-1_820_29610",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V10C20 10.5523 19.5523 11 19 11H5C4.44772 11 4 10.5523 4 10V5Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 5H19V3H5V5ZM19 5V10H21V5H19ZM19 10H5V12H19V10ZM5 10V5H3V10H5ZM5 10H3C3 11.1046 3.89543 12 5 12V10ZM19 10V12C20.1046 12 21 11.1046 21 10H19ZM19 5H21C21 3.89543 20.1046 3 19 3V5ZM5 3C3.89543 3 3 3.89543 3 5H5V5V3Z",
			fill: "var(--colors-grey-1)",
			mask: "url(#path-3-inside-1_820_29610)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.90388 7.48804V6.63204H8.39188C8.46388 6.63204 8.53321 6.63738 8.59988 6.64804C8.66655 6.65871 8.72521 6.68004 8.77588 6.71204C8.82655 6.74138 8.86655 6.78404 8.89588 6.84004C8.92788 6.89604 8.94388 6.96938 8.94388 7.06004C8.94388 7.15071 8.92788 7.22404 8.89588 7.28004C8.86655 7.33604 8.82655 7.38004 8.77588 7.41204C8.72521 7.44138 8.66655 7.46138 8.59988 7.47204C8.53321 7.48271 8.46388 7.48804 8.39188 7.48804H7.90388ZM7.27588 6.14404V9.00004H7.90388V7.97604H8.56388C8.74255 7.97604 8.89455 7.95071 9.01988 7.90004C9.14521 7.84671 9.24655 7.77738 9.32388 7.69204C9.40388 7.60671 9.46121 7.50938 9.49588 7.40004C9.53321 7.28804 9.55188 7.17471 9.55188 7.06004C9.55188 6.94271 9.53321 6.82938 9.49588 6.72004C9.46121 6.61071 9.40388 6.51338 9.32388 6.42804C9.24655 6.34271 9.14521 6.27471 9.01988 6.22404C8.89455 6.17071 8.74255 6.14404 8.56388 6.14404H7.27588Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5718 7.48804V6.63204H12.0598C12.1318 6.63204 12.2012 6.63738 12.2678 6.64804C12.3345 6.65871 12.3932 6.68004 12.4438 6.71204C12.4945 6.74138 12.5345 6.78404 12.5638 6.84004C12.5958 6.89604 12.6118 6.96938 12.6118 7.06004C12.6118 7.15071 12.5958 7.22404 12.5638 7.28004C12.5345 7.33604 12.4945 7.38004 12.4438 7.41204C12.3932 7.44138 12.3345 7.46138 12.2678 7.47204C12.2012 7.48271 12.1318 7.48804 12.0598 7.48804H11.5718ZM10.9438 6.14404V9.00004H11.5718V7.97604H12.2318C12.4105 7.97604 12.5625 7.95071 12.6878 7.90004C12.8132 7.84671 12.9145 7.77738 12.9918 7.69204C13.0718 7.60671 13.1292 7.50938 13.1638 7.40004C13.2012 7.28804 13.2198 7.17471 13.2198 7.06004C13.2198 6.94271 13.2012 6.82938 13.1638 6.72004C13.1292 6.61071 13.0718 6.51338 12.9918 6.42804C12.9145 6.34271 12.8132 6.27471 12.6878 6.22404C12.5625 6.17071 12.4105 6.14404 12.2318 6.14404H10.9438Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2438 6.67204V9.00004H15.8718V6.67204H16.7278V6.14404H14.3878V6.67204H15.2438Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgPpt;
